import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=82fc74f8&scoped=true"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"
import style0 from "./MainSettings.vue?vue&type=style&index=0&id=82fc74f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc74f8",
  null
  
)

export default component.exports